import { grey } from "@mui/material/colors";

const styles = {
  brandCard: {
    cursor: "pointer",
    width: "100%",
    borderRadius: 2,
    border: `1px solid ${grey[300]}`,
    backgroundColor: "white",
  },
  brandContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    minWidth: 0,
    minHeight: "275px",
  },
  brandName: {
    fontWeight: 700,
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  draft: {
    color: "error.main",
  },
  reco: {
    color: "info.main",
  },
  websiteButton: {
    textTransform: "none",
    color: grey[600],
    fontSize: 12,
  },
  divider: {
    borderColor: grey[200],
    my: 2,
  },
  brandInnerContent: {
    flex: "1 0 auto",
    py: 2,
    px: 2,
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
  },
  brandNameContainer: {
    flex: "1 1 auto",
    display: "flex",
    flexDirection: "column",
    gap: 1,
    minWidth: 0,
  },
  logoContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 2,
    minWidth: 0,
  },
  logo: {
    width: { xs: 50, md: 80 },
    height: { xs: 50, md: 80 },
    minWidth: { xs: 50, md: 80 },
    borderRadius: "50%",
    overflow: "hidden",
    border: `1px solid ${grey[300]}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: grey[100],
    flexShrink: 0,
  },
  metadataContainer: {
    overflowX: "auto",
    overflowY: "hidden",
    whiteSpace: "nowrap",
    pr: 0.5,
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      width: 0,
    },
  },
};

export default styles;
